import { suggestDomains } from '@wix/ambassador-premium-domains-v2-suggestion/http';
import { HttpClient } from '@wix/http-client';
import { getDefaultStore } from 'jotai';
import { DomainDataAtom } from '../features/domain/context/domainAtoms';

export class DomainService {
  private store;

  constructor() {
    this.store = getDefaultStore();
  }

  async loadSuggestions(query: string) {
    const ambassadorHttpClient = new HttpClient();
    try {
      const response = await ambassadorHttpClient.request(suggestDomains({ query }));
      const suggestions = response.data.suggestions.map((suggestion) => suggestion.domain);
      this.store.set(DomainDataAtom, {
        availableDomain: suggestions[0],
        suggestions,
      });
    } catch (err) {}
  }
}
